
/* injects from baggage-loader */

'use strict';

import IssuerOnboardingDocumentsController from './issuer-onboarding.documents.controller';
import IssuerOnboardingDocumentsTemplate from './issuer-onboarding.documents.html';

export default class IssuerOnboardingDocumentsComponent {
		constructor() {
				this.templateUrl = IssuerOnboardingDocumentsTemplate;
				this.controller = IssuerOnboardingDocumentsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					onboarding: '<',
					documents: '<'
				};
		}
}
